<template>
    <div class="panel__list__item">
        <span>{{item.start_date | formatDate }} - {{item.current_position ? $t('dashboard.work_experience.ongoing') : ($options.filters.formatDate(item.end_date))}}, {{item.city}}</span>
        <h3 class="purple">{{item.function_title}}</h3>
        <h3>{{item.company_name}}</h3>

        <div class="panel__list__item__actions">
            <span class="panel__list__item__action" @click="editWorkExperience">
                <i class="icons icon-pencil"></i>
                <a class="button--link">{{$t('common.edit')}}</a>
            </span>
            <span class="panel__list__item__action" @click="showDeleteWorkExperienceModal">
                <i class="icons icon-trash"></i>
                <a class="button--link">{{$t('common.delete')}}</a>
            </span>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';

    import { GET_WORK_EXPERIENCE } from '@/store/modules/work-experience';

    @Component
    export default class WorkExperienceItem extends Vue {
        name = 'work-experience-item';

        @Prop()
        item;

        editWorkExperience() {
            this.$modal.show('work-experience-modal', { experience: this.item });
        }

        showDeleteWorkExperienceModal() {
            const content = {
                title: this.$t('modals.delete_work_experience.title'),
                message: this.$t('modals.delete_work_experience.message'),
            };
            this.$modal.show('confirmation-modal', { content, callback: this.deleteWorkExperience, experience: this.item});
        }

        deleteWorkExperience({experience}) {
            experience.remove()
                .then(() => {
                    this.$notify.success(this.$t('notify.work_experience.delete_success'));
                    this.$store.dispatch(GET_WORK_EXPERIENCE, {});
                })
                .catch(err => this.$notify.error(this.$t('notify.work_experience.delete_error')));
        }

    }

</script>



// WEBPACK FOOTER //
// src/components/panels/dashboard/WorkExperienceItem.vue